import { createStore } from 'vuex'

import user from './modules/user'
import claim from './modules/claim'
import voucher from './modules/voucher'
import reports from './modules/reports'

const store = createStore({
  // Making sure that we're doing
  // everything correctly by enabling
  // strict mode in the dev environment.
  strict: process.env.NODE_ENV !== 'production',
  state: {
    SECURITY_TYPES: {
      DR: {
        id: 1,
        display: 'Equity',
        type: 'EQUITY (DRs and Preference Shares)',
      },
      DEBT: {
        id: 2,
        display: 'Debt',
        type: 'DEBT (Interest Bearing Securities)',
      },
    },
    PROCEDURE_TYPES: {
      RAS: {
        id: 1,
        display: 'Relief-At-Source',
        displayShort: 'RAS',
      },
      QR: {
        id: 2,
        display: 'Quick-Refund',
        displayShort: 'QR',
      },
      LF: {
        id: 3,
        display: 'Long-Form',
        displayShort: 'LF',
      },
    },
  },
  modules: {
    user,
    claim,
    voucher,
    reports,
  },
  mutations: {},
  actions: {},
  getters: {},
})

export default store
